/*global cordial, CordialTrack */
import _ from 'underscore';
import { all, call, fork, select, put, take } from 'redux-saga/effects';


export function* setupCordial() {
    const key = yield select(state => state.cordial && state.cordial.key);
    yield call(() => new Promise((resolve) => {
        const tag = document.createElement('script');
        tag.async = true;
        tag.onload = resolve;
        tag.setAttribute('data-auto-track', false);
        tag.setAttribute('data-cordial-track-key', key);
        tag.setAttribute('data-cordial-url', 'track.cordial.io');
        tag.src = 'https://track.cordial.io/track.js';
        document.body.appendChild(tag);
    }));
    yield call(() => new Promise((resolve) =>
        // The Cordial script creates an iframe that sends a window.postMessage
        // event at regular intervals, but we only care that it happens at least once
        // to ensure we have access to window.cordial and its methods
        window.addEventListener('message', function messageListenerEnd(e) {
            if (e.origin === 'https://track.cordial.io') {
                window.removeEventListener('message', messageListenerEnd);
                resolve();
            }
        })
    ));
}

export function* getBrowseEvent() {
    const [ desc, teeup ] = yield all([
        select(state => state.product.description),
        select(state => state.product.teeup),
    ]);

    return desc ? {
        category: desc.categories[0],
        product: desc.product_name,
        productID: desc.code,
        placement: 'teeup', /* TODO: get this directly from module or teeup */
    } : {
        category: teeup.product_type,
        product: teeup.display_name,
        productID: teeup.code,
        placement: 'module',
    };
}

export function* sendSavedBrowseEvents() {
    const events = yield select(state => state.cookie['cordial-events'] || []);
    yield put({ type: 'cookie:remove', payload: 'cordial-events' });

    yield _.last(events, 5).map((event) =>
        call([cordial, cordial.event], 'browse', event)
    );
}

export function* saveBrowseEvent(event) {
    const events = yield select(state => state.cookie['cordial-events'] || []);
    events.push(event);
    yield put({ type: 'cookie:set', payload: {
        name: 'cordial-events',
        value: events,
        opts: { expires: .042 }, // .042 = about 1 hour
    }});
}

export function* sendBrowseEvent(event) {
    try {
        yield call([cordial, cordial.event], 'browse', event);
    } catch(e) {
        yield put({ type: 'raven:error', payload: {error: e, message: 'sendBrowseEvent'} });
    }
}

export function* watchUser() {
    while (true) {
        const user = yield select(state => state.user);
        if (user.member_uuid) {
            try {
                yield call(() => new Promise((resolve, reject) =>
                    cordial.identify(user.member_uuid, {
                        knownContactCallback: resolve,
                        unknownContactCallback: () => reject(new Error('identifyUserFailure')),
                    })
                ));
            } catch(e) {
                try {
                    yield call([cordial, cordial.contact], {m_uuid: user.member_uuid}, {upsert: true});
                } catch(f) {
                    yield put({ type: 'raven:error', payload: {error: f, message: 'cordial.contact'} });
                }
            }
            try {
                yield call(sendSavedBrowseEvents);
            } catch(e) {
                yield put({ type: 'raven:error', payload: {error: e, message: 'sendSavedBrowseEvents'} });
            }
        } else {
            try {
                yield call([cordial, cordial.forget]);
            } catch(e) {
                yield put({ type: 'raven:error', payload: {error: e, message: 'cordial.forget'} });
            }
        }

        yield take(['user:logged-in', 'user:logged-out']);
    }
}

export function* watchBrowseEvents() {
    while (true) {
        const [event, cordial_cid] = yield [
            call(getBrowseEvent),
            call([CordialTrack, CordialTrack.getCordialCookies], 'cID'),
        ];
        if (cordial_cid) {
            yield call(sendBrowseEvent, event);
        } else {
            yield call(saveBrowseEvent, event);
        }

        yield take('product:teeup');
    }
}

export function* root() {
    // NOTE: we're hardcoding the fact that the only supported events are browse events.
    yield take('product:teeup');

    yield call(setupCordial);
    yield call([CordialTrack, CordialTrack.setCordialCookies], 'cID', '', {expires: 0});

    yield all([
        fork(watchUser),
        fork(watchBrowseEvents),
    ]);
}



// WEBPACK FOOTER //
// ./app/sagas/cordial.js